@let context = $context();
@let disableSharing = $safeNavigationMigration(context?.disableSharing);
<!-- {} -->

<master-detail-editor [display]="MasterDetailEditorDisplayMode.Modal" [formGroup]="form">

    <ng-template masterDetailEditorLeftActions>
        <span class="title-text">New File Activity</span>
    </ng-template>


    <ng-template masterDetailEditorRightActions>

        @if (!disableSharing) {
            <sharing-pro [formControl]="sharing" />
        }

        <a class="ml-10" (click)="dismiss()" title="Close">
            <i class="fa-regular fa-xmark"></i>
        </a>

    </ng-template>


    <div class="fieldset" *masterDetailEditorBody>

        <legend>Files</legend>

        <upload-field formControlName="attachments" (uploading)="onUploading($event)"></upload-field>


        <legend>Tags</legend>

        <div class="description">
            To easily organize and find your files, select one or more tags for your chosen files.
        </div>

        <div class="field">
            <label>Tags</label>
            <div class="value">
                <w-select [items]="$tags()" [multiple]="true" formControlName="tags" appendTo="body" [closeOnSelect]="false" dropdownPosition="top" bindLabel="name" bindColor="color" />
            </div>
        </div>


    </div>


    <ng-template masterDetailEditorFooter>
        <w-button label="Cancel" displayStyle="Secondary" size="Medium" (onClick)="dismiss()"></w-button>
        <w-button label="Create Activity" [disabled]="form.invalid || uploading" displayStyle="Primary" size="Medium" (onClick)="onSave()"></w-button>
    </ng-template>

</master-detail-editor>